export default function G2Icon({
  height = 50,
  width = 50,
  className,
}: {
  height?: number;
  width?: number;
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 51 50"
      fill="none"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      role="img"
      className={className}
    >
      <path
        d="M26.176 0C27.8612 0 29.5465 0.160647 31.2018 0.481942L26.176 10.7269C18.0867 10.7232 11.4992 17.1491 11.4992 25.0354C11.8452 36.4823 21.4304 39.3464 26.1797 39.3477C29.6888 39.3477 33.0856 38.1136 35.7408 35.8755L41.2947 45.2661C37.4652 47.9859 32.9386 49.6196 28.2156 49.9866C26.3432 50.0511 18.8441 49.9866 14.5348 47.345C10.3118 45.2508 6.76559 42.0583 4.28855 38.1208C1.81152 34.1833 0.500292 29.6545 0.5 25.0354C0.5 18.3966 3.20514 12.0297 8.02032 7.33529C13.096 2.38699 18.9282 0 26.176 0Z"
        fill="currentColor"
      ></path>
      <path
        d="M31.434 21.461H44.1447L50.5 32.1842L44.1447 42.9184L37.7893 32.1842H25.0824L31.434 21.461Z"
        fill="currentColor"
      ></path>
      <path
        d="M39.2761 1.78903H39.3735C40.9689 1.78903 42.3433 2.20282 43.4968 3.03039C44.0785 3.40402 45.242 4.61788 45.242 6.48431C45.242 8.81735 43.8937 10.2449 41.3658 11.5082L39.954 12.2056C38.4447 12.9504 37.6994 13.6112 37.4935 14.7832H45.1708V17.8866H33.5574V17.3609C33.5549 15.4428 33.9469 13.8534 34.7334 12.5926C35.5198 11.3342 36.8955 10.2181 38.8604 9.24453L39.7667 8.81735C41.3658 8.02872 41.7815 7.35327 41.7815 6.53543C41.7815 5.56424 40.9277 4.86323 39.5345 4.86323C37.8867 4.86323 36.6396 5.69568 35.7745 7.39708L33.5574 5.22469C33.5574 4.46553 35.1029 3.26539 35.8756 2.76021C36.892 2.12929 38.0712 1.79252 39.2761 1.78903Z"
        fill="currentColor"
      ></path>
    </svg>
  );
}
